import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input, TemplateRef, viewChild } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { elementHelp } from '@siemens/element-icons';
import { addIcons, SiIconComponent } from '@siemens/element-ng/icon';
import { ModalRef, SiModalService } from '@siemens/element-ng/modal';
import { SiTooltipDirective } from '@siemens/element-ng/tooltip';

@Component({
    selector: 'tran-help',
    host: {
        class: 'inline-flex items-center h-[1lh]',
        '[attr.title]': 'null'
    },
    imports: [NgTemplateOutlet, TranslatePipe, SiIconComponent, SiTooltipDirective],
    templateUrl: './help.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HelpComponent {
    protected readonly icons = addIcons({ elementHelp });
    private readonly modalService = inject(SiModalService);
    private readonly dialog = viewChild.required<TemplateRef<void>>('dialog');
    private modalRef?: ModalRef;

    public readonly mode = input<'tooltip' | 'dialog'>('tooltip');
    public readonly placement = input<'auto' | 'top' | 'bottom' | 'start' | 'end'>('auto');
    public readonly title = input<string>('');
    public readonly content = input.required<string | TemplateRef<unknown>>();
    public readonly ariaLabel = input<string>('');
    public readonly closeLabel = input<string>('help.close');
    public readonly dialogClass = input<string>('');
    public readonly dialogTemplate = input<TemplateRef<{ close: () => void }>>();

    protected readonly dialogContext = { close: (): void => this.closeDialog() };

    protected readonly contentTemplate = computed(() => {
        const content = this.content();
        return content instanceof TemplateRef ? content : undefined;
    });
    protected readonly contentText = computed(() => {
        const content = this.content();
        return typeof content === 'string' ? content : '';
    });

    protected openDialog(): void {
        this.modalRef = this.modalService.show(this.dialog(), { class: this.dialogClass() });
    }

    protected closeDialog(): void {
        this.modalRef?.hide();
    }
}
